export const UPDATE_FUNC = 'UPDATE_FUNC';
export const UPDATE_MONOMERS = 'UPDATE_MONOMERS';
export const INITIALIZE_MONOMERS = 'INITIALIZE_MONOMERS';